import React from 'react';

class Loading extends React.Component {
  render() {
    return (
      <div id="loader">
        <div className="logo">
          <div className="block-1 block-wrapper">
            <div className="block" />
          </div>
          <div className="block-2 block-wrapper">
            <div className="block" />
          </div>
          <div className="block-3 block-wrapper">
            <div className="block" />
          </div>
          <div className="block-4 block-wrapper">
            <div className="block" />
          </div>
        </div>
      </div>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// src/components/Loading/Loading.js